module.exports = __webpack_public_path__ + "static/media/agentur_process.3d558b2e.jpg";